<template>
    <div>
        <transition>
            <div  v-show="isKeyResultShow&&keyword&&keyResult">
                <div class="close-layer" @click="isKeyResultShow=false" ></div>
            	<div class="m-search-content ">
                    
                	<table class="content-table" >
                    	<tr v-if="keyResult.Cities&&keyResult.Cities.length>0">
                        	<td class="content-label" ><i class="iconfont icon-jiudian"></i>城市</td>
                        	<td>
                            	<div v-for="(city,index) in keyResult.Cities" v-show="index<2" @click="selectCity(city)">
                                    <label v-html="highLight(city.CName,keyword)"></label>
                                    <span class="hotel-count">{{city.HotelCount}}家酒店</span>
                                </div>
                        	</td>
                    	</tr>
                    	<tr v-if="keyResult.Hotels&&keyResult.Hotels.length>0">
                        	<td class="content-label" ><i class="iconfont icon-hotel"></i>酒店</td>
                        	<td>

                            	<div  v-for="hotel in keyResult.Hotels" @click="selectHotel(hotel)">

                                    <h1 class="all-hotel-list-item">
                                        <label v-html="highLight(hotel.Name,keyword)"></label>
                                        <label v-html="highLight(hotel.EnName,keyword)" v-if="hotel.Name!=hotel.EnName"></label>

                                    </h1>
                                    
                                    <span class="all-hotel-list-city">  ({{hotel.City}})</span>
                                    <h2>
                                        <span class="price-one" v-if="hotel.LowestPrice">￥{{hotel.LowestPrice}}起</span>
                                        <span class="score-two">{{hotel.Rate?hotel.Rate:'4.2'}}分,{{hotel.Evaluation}}</span>
                                    </h2>
                                </div>
                        	</td>
                    	</tr>
                    	<tr v-if="keyResult.Landmarks&&keyResult.Landmarks.length>0">
                        	<td class="content-label" ><i class="iconfont icon-lmy-dingwei"></i>地标</td>
                        	<td >
                            	<div v-for="(landmark,idx) in keyResult.Landmarks" v-show="idx<3" @click="selectLandmark(landmark)">
                                    <label v-html="highLight(landmark.Name,keyword)"></label>
                                    <span class="all-hotel-list-city">  ({{landmark.City}})</span>
                                    <span class="hotel-count">{{landmark.HotelCount}}家酒店</span>
                                </div>
                        	</td>
                    	</tr>
                	</table> 

                    <table class="content-table" v-show="!keyResult">
                        <tr>
                            <td class="content-label" ><i class="iconfont icon-jiudian"></i>城市</td>
                            <td>
                                <div class="preview-block"></div>
                            </td>
                        </tr>
                        <tr>
                            <td class="content-label" ><i class="iconfont icon-hotel"></i>酒店</td>
                            <td>
                                <div class="preview-block"></div>
                            </td>
                        </tr>
                        <tr >
                            <td class="content-label" ><i class="iconfont icon-lmy-dingwei"></i>地标</td>
                            <td >
                                <div class="preview-block"></div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
	export default{
		name:'searchALl',
		props:{
			keyword:{
				type:String,
				default:''
			},
			isKeyResultShow:{
				type:Boolean,
				default:false
			},
            productType:{
			    type:String,
                default:null
            }
		},
		data(){
			return{
				keyResult:'',
				key:''
			}
		},
		watch:{
            keyword(val){
                this.getHotelAndLandmarks(val);
            }
        },
		methods:{
			//选择城市
			selectCity(city){
				this.$emit('selectCity',city)
            },
			//选择酒店
			selectHotel(hotel){
				
				this.$emit('selectHotel',hotel)
            },
			//选择地标
			selectLandmark(landmark){
				// console.log(landmark);
				this.$emit('selectLandmark',landmark)
            },
            //字符串关键字高亮
            highLight(string,key){
                if(!string)return;
                var array=[];
                var str='';
                array=string.split('');
                for(var i=0;i<array.length;i++){
                    if(key.indexOf(array[i])>-1){
                        str+='<span class="key-words">'+array[i]+'</span>';
                    }else{
                        str+=array[i];
                    }
                }
                return str;
            },
  
            //模糊查询
            getHotelAndLandmarks(){
                var that=this;
                var params={
                    q:that.keyword,
                    pt:that.productType,
                    page:1,
                    pageSize:10,
                }
                that.getRequest({
                    url: that.Api.getHotelAndLandmarks,
                    params: params
                }).then(res => {
                    if (res&&res.IsSuccess) {
                        that.keyResult=res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    }
                });
            },
		}
	}
</script>


// WEBPACK FOOTER //
// src/common/cmpnt/searchAll/SearchAll.vue